import { createStore } from "redux";
import { MedicationReducer } from "./MedicationReducer";

export const PatientDataStore = createStore(MedicationReducer);